import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-bulk-move .company { width: 11rem; }
			#sm-bulk-move .warehouse { width: 10rem; }
			#sm-bulk-move .location { width: 10rem; }
			#sm-bulk-move #movement_kind { width: 20rem; }
			#sm-bulk-move #reason { width: 22rem; }
		</style>
		<form id="sm-bulk-move" class="form" autocomplete="off">
			<datalist id="sm-bm-companies"></datalist>
			<datalist id="sm-bm-warehouses-t"></datalist>
			<datalist id="sm-bm-locations-t"></datalist>
			<div class="title">Movimentar seleção</div>
			<p class="mts muted" style="max-width:40rem">Para cada linha selecionada, move a quantidade do tipo de origem escolhido (disponível ou bloqueado) para o destino informado. Saldo <strong>reservado não pode ser movimentado</strong>.</p>
			<div class="fsb mtl">
				<label>De (origem)<sup>*</sup>
					<select id="source_stock" required>
						<option value="L">Disponível</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<label>Para (destino)<sup>*</sup>
					<select id="target_stock" required>
						<option value="L">Disponível</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<span></span>
			</div>
			<div class="fsb mtm">
				<label>Empresa destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="sm-bm-companies" required>
				</label>
				<label>Armazém destino<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="sm-bm-warehouses-t" required>
				</label>
				<label>Posição destino<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="sm-bm-locations-t" required placeholder="Lista do armazém; busca respeita maiúsculas/minúsculas" title="Após escolher empresa e armazém, liste ou pesquise o endereço (S-1 ≠ s-1).">
				</label>
			</div>
			<div class="fsb mtm">
				<label>Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label>Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-bulk-move',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#sm-bm-companies', 'companies', { labels: [ 'nick' ], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#source_stock' }, types: [ types.select() ] },
		{ properties: { selector: '#target_stock' }, types: [ types.select() ] },
		{ properties: { selector: '#target_warehouse_company_id' }, types: [ types.pubsub(), types.datalist() ] },
		{ properties: { selector: '#target_warehouse_id' }, types: [ types.pubsub(), types.datalist(), types.observer('target_warehouse_company_id'), types.obs_load_options('warehouses') ] },
		{ properties: { selector: '#target_location_id' }, types: [
			types.pubsub(),
			types.datalist({ caseSensitive: true }),
			types.observer([ 'target_warehouse_company_id', 'target_warehouse_id' ]),
			types.obs_location_search_api({ companyKey: 'target_warehouse_company_id', warehouseKey: 'target_warehouse_id' }),
		] },
		{ properties: { selector: '#movement_kind' }, types: [ types.opt_movement_kind(), types.datalist() ] },
		{ properties: { selector: '#reason' }, types: [] },
	],
};
